/**
 * Syncs cart attribute `contains_weight_based` for HidePay payment rules.
 */
(function () {
  const ATTR = 'contains_weight_based';
  const ORDER_NOTE_ATTR = 'Algemene opmerking';
  const LINE_PROPERTY = '_gaston_weight_based';
  const CHECKOUT_PATH = '/checkout';
  const CHECKOUT_DEBOUNCE_MS = 800;

  let syncInFlight = null;
  let checkoutLockUntil = 0;

  function releaseCheckoutLock() {
    checkoutLockUntil = 0;
  }

  function lineItemIsWeightBased(item) {
    if (!item) return false;
    if (item.unit_price_measurement != null) return true;

    const props = item.properties || {};
    const flag = props[LINE_PROPERTY];
    if (flag === true || flag === 'true' || flag === '1') return true;

    return item.final_line_price === 0;
  }

  function readFlagFromDom() {
    const input = document.querySelector('[data-gaston-cart-attribute-input]');
    if (input) return input.value === 'true';

    const el = document.querySelector('[data-gaston-contains-weight-based]');
    if (!el) return null;
    return el.getAttribute('data-gaston-contains-weight-based') === 'true';
  }

  async function readFlagFromCartApi() {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
      if (!response.ok) return null;
      const cart = await response.json();
      if (!cart?.items?.length) return false;
      return cart.items.some(lineItemIsWeightBased);
    } catch {
      return null;
    }
  }

  async function resolveWeightBasedFlag() {
    const fromApi = await readFlagFromCartApi();
    if (fromApi !== null) return fromApi;

    const fromDom = readFlagFromDom();
    if (fromDom !== null) return fromDom;

    return false;
  }

  function updateHiddenAttributeInputs(value) {
    document.querySelectorAll('[data-gaston-cart-attribute-input]').forEach((input) => {
      input.value = value;
    });
    document.querySelectorAll('[data-gaston-contains-weight-based]').forEach((el) => {
      el.setAttribute('data-gaston-contains-weight-based', value);
    });
  }

  function readOrderNoteFromDom() {
    const field = document.querySelector('[data-cart-order-note-field]');
    return field ? field.value : null;
  }

  function syncCartAttributes(containsWeightBased) {
    if (!window.routes?.cart_update_url || typeof fetchConfig !== 'function') {
      return Promise.resolve(containsWeightBased);
    }

    const value = containsWeightBased ? 'true' : 'false';
    updateHiddenAttributeInputs(value);

    const attributes = {
      [ATTR]: value,
    };

    const orderNote = readOrderNoteFromDom();
    if (orderNote !== null) {
      attributes[ORDER_NOTE_ATTR] = orderNote;
    }

    const body = JSON.stringify({ attributes });

    return fetch(`${window.routes.cart_update_url}`, { ...fetchConfig(), body }).then(() => containsWeightBased);
  }

  async function syncFromDocument() {
    if (syncInFlight) return syncInFlight;

    syncInFlight = resolveWeightBasedFlag()
      .then((flag) => syncCartAttributes(flag))
      .finally(() => {
        syncInFlight = null;
      });

    return syncInFlight;
  }

  function resolveCheckoutUrl() {
    if (window.routes?.checkout_url) return window.routes.checkout_url;
    return CHECKOUT_PATH;
  }

  async function onCheckoutSubmit(event) {
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;

    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart')) return;

    const now = Date.now();
    if (now < checkoutLockUntil) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    checkoutLockUntil = now + CHECKOUT_DEBOUNCE_MS;

    try {
      const flag = await readFlagFromCartApi();
      const resolved = flag !== null ? flag : await resolveWeightBasedFlag();
      const noteEl = document.querySelector('cart-note[data-attribute-key]');
      if (noteEl && typeof noteEl.save === 'function') {
        await noteEl.save();
      }
      await syncCartAttributes(resolved);
      window.location.assign(resolveCheckoutUrl());
    } catch (e) {
      console.error('GastonCartPayment: failed to sync cart attribute', e);
      releaseCheckoutLock();
      form.submit();
    }
  }

  function onCartChanged() {
    releaseCheckoutLock();
    syncFromDocument();
  }

  function init() {
    syncFromDocument();

    document.addEventListener('submit', onCheckoutSubmit, true);

    window.addEventListener('pageshow', () => {
      releaseCheckoutLock();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.source === 'cart-items' || event?.source === 'product-form') {
          requestAnimationFrame(onCartChanged);
        }
      });
    }
  }

  window.GastonCartPayment = {
    ATTR,
    LINE_PROPERTY,
    lineItemIsWeightBased,
    readFlagFromDom,
    readFlagFromCartApi,
    resolveWeightBasedFlag,
    ORDER_NOTE_ATTR,
    syncCartAttributes,
    syncFromDocument,
    releaseCheckoutLock,
    init,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
